import { FilterGroup } from '@/common/models';

import Filter from './Filter';
import * as FilterComparisonOperator from './FilterComparisonOperator';
import FilterLogicalOperator from './FilterLogicalOperator.enum';

export default class FilterCollection {
  filters: Array<Filter | FilterGroup>;
  logicalOperator: string;

  constructor(filters = [], logicalOperator = FilterLogicalOperator.AND) {
    this.filters = filters;
    this.logicalOperator = logicalOperator;
  }

  get isEmpty() {
    return !this.filters.some((x) => {
      return x instanceof Filter ? x.values.length > 0 : !x.isEmpty;
    });
  }

  get expression() {
    let queryString = '';
    this.filters.forEach((filter) => {
      if (!filter.isEmpty) {
        if (queryString !== '') {
          queryString += ` ${this.logicalOperator} `;
        }
        if (filter instanceof FilterCollection) {
          queryString += `(${filter.expression})`;
        } else {
          queryString += filter.toQueryParam();
        }
      }
    });
    return queryString;
  }

  addFilter(filter) {
    this.filters.push(filter);
  }

  toQueryParam() {
    return `$filter=${this.expression}`;
  }

  static areFilterValuesEmpty(filters: Array<Filter | FilterGroup>) {
    return filters.every((x) => {
      if (x instanceof Filter) {
        return x.isEmpty;
      }
      return x instanceof FilterGroup && (x.isEmpty || this.areFilterValuesEmpty(x.filters));
    });
  }

  static for(prop, values, comparisonOperator = FilterComparisonOperator.EQUAL) {
    return new FilterCollection([new Filter(prop, values, comparisonOperator)]);
  }
}
